import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getDataMaster } from "./api";
import { masterStore } from "./store";

export default function useFetchMaster() {
  const { setMaster } = masterStore();
  
  const { isLoading, data, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["master"],
    queryFn: getDataMaster,
  });

  useEffect(() => {
    if (data) setMaster(data);
  }, [data, setMaster]);

  return { isLoading, data, isError, error, isFetching, refetch };
}
